import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Title from '../../components/Title';
import { TbStarsFilled } from "react-icons/tb"
import { db } from '../../services/firebaseConnection';
import { updateDoc, getDoc, doc } from 'firebase/firestore';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';

export default function EditCargo() {
  const [nome, setNome] = useState('');
  const [permissoes, setPermissoes] = useState([]);
  const [tipo, setTipo] = useState('');
  const todasPermissoes = [
    "home",
    "calendario",
    "deletar_itens",


    "relatorio_lista",
    "relatorio_novo",
    "relatorio_editar",


    "usuario_lista",
    "usuario_novo",
    "usuario_editar",


    "cidade_lista",
    "cidade_novo",
    "cidade_editar",



    "cargo_lista",
    "cargo_novo",
    "cargo_editar",

    "igreja_lista",
    "igreja_novo",
    "igreja_editar"
  ];

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const getCargoFromDatabase = async () => {
      try {
        const cargoDocRef = doc(db, 'Cargo', id);
        const cargoDoc = await getDoc(cargoDocRef);

        if (cargoDoc.exists()) {
          const cargoData = cargoDoc.data();
          setNome(cargoData.nome || '');
          setPermissoes(cargoData.permissoes || []);
          setTipo(cargoData.tipo || ''); 
        } else {
          toast.error('Cargo não encontrado.');
          navigate('/cargo');
        }
      } catch (error) {
        console.error('Erro ao buscar cargo:', error);
        toast.error('Erro ao carregar dados.');
      }
    };

    getCargoFromDatabase();
  }, [id, navigate]);

  const handlePermissionChange = (event) => {
    const { value, checked } = event.target;
    setPermissoes((prevPermissoes) => {
      if (checked) {
        return [...prevPermissoes, value];
      } else {
        return prevPermissoes.filter((permission) => permission !== value);
      }
    });
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setPermissoes(todasPermissoes);
    } else {
      setPermissoes([]);
    }
  };

  const handleTipoChange = (event) => {
    setTipo(event.target.value);
  };

  async function handleEdit(e) {
    e.preventDefault();

    if (nome !== '' && tipo !== '') {
      const cargoDocRef = doc(db, 'Cargo', id);

      await updateDoc(cargoDocRef, {
        nome: nome,
        permissoes: permissoes,
        tipo: tipo 
      })
        .then(() => {
          toast.success('Cargo atualizado!');
          navigate('/cargo');
        })
        .catch((error) => {
          console.log(error);
          toast.error('Erro ao atualizar cargo.');
        });
    } else {
      toast.error('Preencha todos os campos.');
    }
  }

  return (
    <div>
      <Header />

      <div className="content">
        <Title name={nome ? `Editar Cargo - ${nome}` : 'Editar Cargo'}>
          <TbStarsFilled size={25} />
        </Title>

        <div className="container">
          <form className="form-profile" onSubmit={handleEdit}>
            <Row className="mb-3">
              <Col>
                <label>Nome</label>
                <input
                  type="text"
                  placeholder="Nome"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  className="form-control input-name"
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <label>Permissões</label>
                <label id="all-permissions">
                  <input
                    type="checkbox"
                    value="todos"
                    checked={permissoes.length === todasPermissoes.length}
                    onChange={handleSelectAll}
                    className="form-check-input"
                  />
                  Todos
                </label>
                <div className="permissions-container">
                  {todasPermissoes.map((permissao) => (
                    <label key={permissao}>
                      <input
                        type="checkbox"
                        value={permissao}
                        checked={permissoes.includes(permissao)}
                        onChange={handlePermissionChange}
                      />
                      {permissao.replace('_', ' ')}
                    </label>
                  ))}
                </div>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <label>Tipo</label>
                <div className="radio-container">
                  <label>
                    <input
                      type="radio"
                      value="Admin"
                      checked={tipo === 'Admin'}
                      onChange={handleTipoChange}
                    />
                    Administradores
                  </label>
                  <label>
                    <input
                      type="radio"
                      value="UserP"
                      checked={tipo === 'UserP'}
                      onChange={handleTipoChange}
                    />
                    Porteiros / Auxiliares da Porta
                  </label>
                  <label>
                    <input
                      type="radio"
                      value="UserS"
                      checked={tipo === 'UserS'}
                      onChange={handleTipoChange}
                    />
                    Operadores de Som
                  </label>
                </div>
              </Col>
            </Row>

            <Button type="submit" variant="primary">
              Atualizar
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
